import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const SystemDisbursementRoutes = defineRoute({
    record: {
        route: {
            path: "/system-disbursement",
            component: () => loadView(import("./SystemDisbursementTable.vue")),
        },
    },
    create: {
        route: {
            path: "/system-disbursement/create",
            component: () => loadView(import("./SystemDisbursementCreate.vue")),
        },
    },
    detail: {
        route: {
            path: "/system-disbursement/detail/:id",
            component: () => loadView(import("./SystemDisbursementDetail.vue")),
        },
        build(id: string) {
            return `/system-disbursement/detail/${id}`;
        },
    },
});
